import { render, staticRenderFns } from "./GroupDropdownItem.vue?vue&type=template&id=344bb002&scoped=true&"
import script from "./GroupDropdownItem.vue?vue&type=script&lang=js&"
export * from "./GroupDropdownItem.vue?vue&type=script&lang=js&"
import style0 from "./GroupDropdownItem.vue?vue&type=style&index=0&id=344bb002&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344bb002",
  null
  
)

export default component.exports